import SBEditable from "../../../components/sbEditable/sbEditable"
import RichTextWithBlokRenderer from "../../../components/richTextRenderer/richTextRenderer"
import StoryblokImageBasic from "../../../components/storyblokImageBasic/storyblokImageBasic"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"

import styles from "./image.module.scss"

/// >> Blok:image
// image:Storyblok Image
// caption:Richtext
// image_alignment:text:left|center|right
// caption_location:text:above|below
// caption_alignment:text
function Image({ blok }) {

  let imageAlignmentStyle = ""
  switch (blok.image_alignment) {
    case "center":
      imageAlignmentStyle = styles.imageCenter;
      break;
    case "right":
      imageAlignmentStyle = styles.imageRight;
      break;
    default:
      imageAlignmentStyle = styles.imageLeft;
      break;
  }

  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <figure className={`${styles.wrapper} ${imageAlignmentStyle}`}>
        {blok.caption && blok.caption_location === "above" ? RenderCaption(blok) : null}
        {blok.image && blok.image.filename ? <StoryblokImageBasic image={blok.image} /> : null}
        {blok.caption && blok.caption_location !== "above" ? RenderCaption(blok) : null}
      </figure>
    </SBEditable>
  )
}

function RenderCaption(blok) {
  return (
    <figcaption className={blok.caption_alignment}>
      <RichTextWithBlokRenderer document={blok.caption} />
    </figcaption>
  )
}

export default Image